import { ActionsUnion } from "./HeaderThemes.actions";
import { CATEGORIES_HEADER_LOADED, GetHeaderThemeLoaded, SET_ACTIVE_USER_ADDRESS, SET_REDIRECT, SIGN_IN, SIGN_OUT, SITE_THEME_LOADED, mobile_searching, recalculate_cart_total, set_active_branch, set_active_location,   set_auth_modal_type,   set_mobile_search_results,   set_vendor_branches,   set_voucher, set_voucher_percentage, show_branches_modal, show_header_cart, toggle_map, update_auth_modal_status, update_cart_display_status, update_mobile_search_bar_display } from "./constants/constants";
import { HeaderState } from "../../entites/HeaderThemes.model";



function getIntialState()
{
  let initialState : HeaderState  = {
    HeaderTheme1 :   {},
    display_map: false,
    show_header_auth_modal: false,
    user: {},
    cart_display_status: false,
    active_location: false,
    show_header_cart: true,
    redirect: '',
    voucher_percentage: 0,
    cart_total_with_voucher: 0,
    active_user_address: {},
    voucher_code: '',
    cart_total: 0,
    header_categories : [],
    cart_list: [],
    branches_modal: {
      show: false,
      vendor_branches: [],
      active_branch: {}
    },
    auth_modal: {
      type: 1
    },
    mobile_search_view: {
      display: false,
      search_text: '',
      search_result: []
    },
    signedIn: false
  };

  return initialState
}

export function HeaderReducer (state = getIntialState(), action: ActionsUnion) {

  switch ( action.type )
  {

    case GetHeaderThemeLoaded:
    return {...state,SubCategories:action.data};

    case toggle_map:
    return {
      ...state,
      display_map: action.data
    };

    case update_auth_modal_status:
    return {
      ...state,
      show_header_auth_modal: action.data
    };

    case SIGN_OUT:
    return {
      ...state,
      signedIn: false,
      user: getIntialState().user
    };

    case update_cart_display_status:
      console.log(action.data)
    return {...state,cart_display_status:action.data};

    case set_active_location:
    return {
      ...state,
      active_location: action.data
    };


    case show_header_cart:
    return {
      ...state,
      show_header_cart: action.data
    };

    case SET_REDIRECT:
      return {
        ...state,
        redirect: action.data
      };

    break;

    case SIGN_IN:
    return {
      ...state,
      signedIn: true,
      user: action.data
    };
    
    

    case set_voucher_percentage:
    return {
      ...state,
      voucher_percentage: action.data
    };


    case SET_ACTIVE_USER_ADDRESS:
    return{
      ...state,
      active_user_address: action.data
    };

    case set_voucher:
    return {
      ...state,
      voucher_code: action.data
    };

    case recalculate_cart_total:
    return {
      ...state,
      cart_total: action.data
    };


    case CATEGORIES_HEADER_LOADED:
    return {
      ...state,
      header_categories: action.data
    };


    case SITE_THEME_LOADED:
    return {
      ...state,
      site_theme: action.data
    };

    case show_branches_modal:
    return {
      ...state,
      branches_modal: {
        ...state.branches_modal,
        show: action.data
      }
    };


    case set_vendor_branches:
    return {
      ...state,
      branches_modal: {
        ...state.branches_modal,
        vendor_branches: action.data
      }
    };


    case set_active_branch:
    return {
      ...state,
      branches_modal: {
        ...state.branches_modal,
        active_branch: action.data
      }
    };


    case set_auth_modal_type:
      return {
        ...state,
        auth_modal: {
          ...state.auth_modal,
          type: action.data
        }
    };


    case update_mobile_search_bar_display:
      return {
        ...state,
        mobile_search_view: {
          ...state.mobile_search_view,
          display: action.data
        }
    };


    case mobile_searching:
      return {
        ...state,
        mobile_search_view: {
          ...state.mobile_search_view,
          search_text: action.data
        }
    };


    case set_mobile_search_results:
      return {
        ...state,
        mobile_search_view: {
          ...state.mobile_search_view,
          search_result: action.data
        }
    };




    default:
    return state;

  }

}
